import { SubscriptionBreakdownProps } from "./SubscriptionBreakdown.types";
import { PaidSubscriptionBreakdown } from "./PaidSubscriptionBreakdown";
import { FreeSubscriptionBreakdown } from "./FreeSubscriptionBreakdown";
import { InvalidSubscriptionBreakdown } from "./InvalidSubscriptionBreakdown";

export const SubscriptionBreakdown = (props: SubscriptionBreakdownProps) => {
  const { type, productName } = props;

  if (type === "invalid") {
    const { errorDescription } = props;
    return (
      <InvalidSubscriptionBreakdown
        productName={productName}
        errorDescription={errorDescription}
      />
    );
  }

  if (type === "free") {
    const { productDescription } = props;
    return (
      <FreeSubscriptionBreakdown
        productName={productName}
        productDescription={productDescription}
      />
    );
  }

  const {
    price,
    currency,
    productDescription,
    hasPaymentMethod,
    trialEndDate,
    nextPaymentDate,
    lastPaymentDate,
    cancellationDate,
    scheduledCancellationDate,
    credits,
    estimatedPaymentMethodRequiredDate,
    disabled,
    userInfo,
    handleCancelSubscription,
    onRestoreSubscriptionClick,
    onUpdateTrialPeriodClick,
    handleCancelSubscriptionAtPeriodEnd,
    handleCancelScheduledSubscriptionCancellation,
    handleTurnToFree,
  } = props;

  return (
    <PaidSubscriptionBreakdown
      price={price}
      trialEndDate={trialEndDate}
      productName={productName}
      productDescription={productDescription}
      currency={currency}
      hasPaymentMethod={hasPaymentMethod}
      nextPaymentDate={nextPaymentDate}
      lastPaymentDate={lastPaymentDate}
      cancellationDate={cancellationDate}
      scheduledCancellationDate={scheduledCancellationDate}
      estimatedPaymentMethodRequiredDate={estimatedPaymentMethodRequiredDate}
      credits={credits}
      disabled={disabled}
      userInfo={userInfo}
      handleCancelSubscription={handleCancelSubscription}
      onRestoreSubscriptionClick={onRestoreSubscriptionClick}
      onUpdateTrialPeriodClick={onUpdateTrialPeriodClick}
      handleCancelSubscriptionAtPeriodEnd={handleCancelSubscriptionAtPeriodEnd}
      handleCancelScheduledSubscriptionCancellation={
        handleCancelScheduledSubscriptionCancellation
      }
      handleTurnToFree={handleTurnToFree}
    />
  );
};
